module.exports = __webpack_public_path__ + "static/media/cow.6161e3d4.svg";